import React from 'react';
import { useTranslation } from 'react-i18next';
import classnames from 'classnames';
import Flex from '@wix/da-ds/pkg/Flex';
import CommissionPointsAndPrice from '../../../../../CommissionPointsAndPrice';
import s from './PriceBlock.scss';
var PriceBlock = function (_a) {
    var priceTextClassName = _a.priceTextClassName, price = _a.price, priceLabel = _a.priceLabel, priceLabelOnTop = _a.priceLabelOnTop, dollarsCost = _a.dollarsCost;
    var t = useTranslation().t;
    return dollarsCost !== undefined ? (React.createElement("div", { className: s['price-wrapper'] },
        React.createElement(CommissionPointsAndPrice, { points: price, price: dollarsCost }))) : (React.createElement(Flex, { justifyContent: priceLabelOnTop ? 'flex-end' : 'center', direction: priceLabelOnTop ? 'column-reverse' : 'column', className: classnames(s['price'], priceLabelOnTop && s['price-on-top']) },
        React.createElement("div", { className: classnames(s['price-value'], priceTextClassName) }, price),
        React.createElement("div", { className: classnames(s['price-label'], priceTextClassName) }, t(priceLabel))));
};
PriceBlock.displayName = 'PriceBlock';
export default PriceBlock;
//# sourceMappingURL=PriceBlock.js.map